__turbopack_context__.v({
  "root": "background-image-module-scss-module__MHzkIG__root",
});
